import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the speciality.
 */
export const TextFieldSpeciality = ({ values, handleChange }) => (
    <TextField
        fullWidth
        label={t('users.fields.specialty')}
        type="text"
        name="speciality"
        value={values.speciality}
        onChange={handleChange}
    />
);

TextFieldSpeciality.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
};
